module.exports = __webpack_public_path__ + "img/bookmark.73cd925d.svg";